var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Button, CircularProgress, Container, Grid2, Toolbar, Typography, useTheme } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { objectToQueryString, validateEmail } from "@/utils";
import axiosHttp from '@/api';
import { get as _get } from 'lodash';
import { useSessionContext } from "@/contexts/SessionContext";
import { useNavigate } from "react-router-dom";
import AppBar from '../components/AppBar';
var LoginSVG = require("@/static/login.svg");
export default (function () {
    var theme = useTheme();
    var _a = useSessionContext(), token = _a.token, organization = _a.organization, checkingToken = _a.checkingToken, setOrganization = _a.setOrganization, whiteLabel = _a.whiteLabel, subdomain = _a.subdomain, onLogin = _a.onLogin, onLogout = _a.onLogout, loginLoading = _a.loginLoading;
    var navigate = useNavigate();
    var _b = useState(null), orgInput = _b[0], setOrgInput = _b[1];
    var _c = useState(true), showOrgInput = _c[0], setShowOrgInput = _c[1];
    var emailInputRef = useRef(null);
    var _d = React.useState(null), globalError = _d[0], setGlobalError = _d[1];
    var _e = React.useState({ email: null, emailError: null }), state = _e[0], setState = _e[1];
    var handleInputChange = function (e) {
        setState(function (prev) {
            var _a;
            return __assign(__assign({}, prev), (_a = {}, _a["".concat(e.target.name, "Error")] = null, _a));
        });
        var _a = e.target, name = _a.name, value = _a.value;
        setState(function (prev) {
            var _a;
            return __assign(__assign({}, prev), (_a = {}, _a[name] = value, _a));
        });
    };
    var clearInputFields = function () {
        if (emailInputRef.current)
            emailInputRef.current.value = '';
    };
    var getBasePublicURL = function (url) {
        if (url && url.includes("hitwit-public.s3.amazonaws.com")) {
            return url.replace("hitwit-public.s3.amazonaws.com", "static.hitwit.ai");
        }
        return url;
    };
    var handleSubmit = function () { return __awaiter(void 0, void 0, void 0, function () {
        var err, response, whitelisted;
        var _a, _b, _c;
        var _d, _e;
        return __generator(this, function (_f) {
            switch (_f.label) {
                case 0:
                    err = {};
                    if (!(state === null || state === void 0 ? void 0 : state.email))
                        err = __assign(__assign({}, err), (_a = {}, _a["emailError"] = "Please enter valid email", _a));
                    if ((state === null || state === void 0 ? void 0 : state.email) && !validateEmail(state === null || state === void 0 ? void 0 : state.email))
                        err = __assign(__assign({}, err), (_b = {}, _b["emailError"] = 'Please enter valid email', _b));
                    response = null;
                    if (!(state === null || state === void 0 ? void 0 : state.email)) return [3 /*break*/, 2];
                    return [4 /*yield*/, axiosHttp("?".concat(objectToQueryString({
                            domain_name: subdomain,
                            email: (_d = state === null || state === void 0 ? void 0 : state.email) === null || _d === void 0 ? void 0 : _d.trim().toLowerCase(),
                            action: 'is_org_email_whitelisted'
                        })), {
                            headers: __assign({}, (subdomain ? { 'X-Domain': subdomain } : {})),
                        })];
                case 1:
                    response = _f.sent();
                    _f.label = 2;
                case 2:
                    whitelisted = response ? (_e = response === null || response === void 0 ? void 0 : response.data) === null || _e === void 0 ? void 0 : _e.whitelisted : false;
                    if (subdomain && (!whitelisted && ((state === null || state === void 0 ? void 0 : state.email) && _get(whiteLabel, 'emailSuffix', null) && (state === null || state === void 0 ? void 0 : state.email.indexOf(_get(whiteLabel, 'emailSuffix', ''))) === -1)))
                        err = __assign(__assign({}, err), (_c = {}, _c["emailError"] = "Please use your ".concat(_get(whiteLabel, 'emailSuffix', "@".concat(subdomain)), " email"), _c));
                    setState(function (prev) { return __assign(__assign({}, prev), err); });
                    console.log(err);
                    if (Object.keys(err).length === 0) {
                        try {
                            onLogin("Username-Password-Authentication", state === null || state === void 0 ? void 0 : state.email);
                        }
                        catch (e) {
                            setState({ email: null, emailError: null });
                            clearInputFields();
                            setGlobalError(e);
                            setTimeout(function () { return setGlobalError(null); }, 5000);
                        }
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        if (token)
            navigate("/home");
    }, [token]);
    if (checkingToken) {
        return (_jsx(Box, { sx: { height: '100%', mt: 3 }, children: _jsx(Box, { sx: { display: 'flex', flexDirection: 'column', alignItems: 'center' }, children: _jsx(Box, { sx: { height: 200, display: 'flex', alignItems: 'center', justifyContent: 'center' }, children: _jsx(CircularProgress, { size: 48 }) }) }) }));
    }
    if (loginLoading) {
        return (_jsx(Box, { sx: { height: '100%', mt: 3 }, children: _jsxs(Box, { sx: { display: 'flex', flexDirection: 'column', alignItems: 'center' }, children: [_jsx(Typography, { variant: "h6", sx: {}, textAlign: "center", children: "Login" }), _jsx("img", { style: { marginTop: 4, marginBottom: 4, maxWidth: 250, height: 250, objectFit: 'contain' }, src: LoginSVG }), _jsxs(Box, { sx: { display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }, children: [_jsx(CircularProgress, { size: 48 }), _jsx(Button, { sx: { mt: 4 }, color: "primary", onClick: function () { return window.location.reload(); }, children: "Cancel" })] })] }) }));
    }
    return (_jsxs(Box, { sx: { height: '100%', mt: 3 }, children: [_jsx(AppBar, { position: "fixed", sx: {}, children: _jsxs(Toolbar, { style: { background: 'transparent' }, children: [_jsx("img", { style: { cursor: 'pointer', minWidth: 30, height: (whiteLabel === null || whiteLabel === void 0 ? void 0 : whiteLabel.height) ? whiteLabel === null || whiteLabel === void 0 ? void 0 : whiteLabel.height : 48, width: 'auto', padding: '0 4px' }, src: getBasePublicURL((whiteLabel === null || whiteLabel === void 0 ? void 0 : whiteLabel.logoFull) || 'https://static.hitwit.ai/hitwit_new.light.png') }), _jsx(Box, { style: { flexGrow: 1 } })] }) }), _jsx(Container, { maxWidth: "md", children: _jsx(Grid2, { container: true, spacing: 2, direction: "column", alignItems: "center", children: _jsx(Grid2, { size: { xs: 12, sm: 12, md: 8 }, children: _jsxs(Box, { sx: { display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '98vh' }, children: [_jsx(Typography, { variant: "h5", sx: {}, textAlign: "center", children: "Login" }), _jsx("img", { style: { marginTop: 4, marginBottom: 4, maxWidth: 250, height: 250, objectFit: 'contain' }, src: require("@/static/login.svg") }), _jsx(Button, { variant: "contained", onClick: function () {
                                        onLogin();
                                    }, children: "Login" })] }) }) }) })] }));
});
